import { useState } from 'react';
import { LocalStorageFavouriteLocker, Locker, PreviouslyUsedLocker, GenericNode, LockerPluginOptions } from '../data/LockerDataTypes';
import { getFavouriteLockers, getPreviouslyUsedLockers } from '../services/lockerService';
import { getLockerPluginOptions } from '../services/queryParams';

import type { ReactSetState } from '../utils/types';
import { ContextProviderProps, createContext } from '../common/contextFactory';

type SpecificLockerActionProps = {
    selectedLocker: Locker;
    setSelectedLocker: ReactSetState<Locker>;
    lockerListSelected: Locker;
    setLockerListSelected: ReactSetState<Locker>;
    favouriteLockers: LocalStorageFavouriteLocker[];
    setFavouriteLockers: ReactSetState<LocalStorageFavouriteLocker[]>;
    previouslyUsedLockers: PreviouslyUsedLocker[];
    setPreviouslyUsedLockers: ReactSetState<PreviouslyUsedLocker[]>;
}
const [useSpecificLockerActionContext, Provider] = createContext<SpecificLockerActionProps>('SpecificLockerActionCtx');

const useInitSpecificLockerActionContext = () => {
    const { countryCode } = getLockerPluginOptions();
    const [selectedLocker, setSelectedLocker] = useState<Locker>({} as Locker);
    const [lockerListSelected, setLockerListSelected] = useState<Locker>({} as Locker);
    const [favouriteLockers, setFavouriteLockers] = useState<LocalStorageFavouriteLocker[]>(getFavouriteLockers(countryCode));
    const [previouslyUsedLockers, setPreviouslyUsedLockers] = useState(getPreviouslyUsedLockers(countryCode));

    const specificLockerActionProps: SpecificLockerActionProps = {
        selectedLocker,
        setSelectedLocker,
        lockerListSelected,
        setLockerListSelected,
        favouriteLockers: favouriteLockers,
        setFavouriteLockers: setFavouriteLockers,
        previouslyUsedLockers,
        setPreviouslyUsedLockers
    };
    return specificLockerActionProps;
};

const SpecificLockerActionContextProvider = ({ children }: ContextProviderProps) => {
    return <Provider value={useInitSpecificLockerActionContext()}>
        {children}
    </Provider>;
};

export { useSpecificLockerActionContext, SpecificLockerActionContextProvider };

